'use client'

import React, { FormEvent, useState } from 'react';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { toastRef } from '@/vars/global';
import { AuthServerResponse } from '@/types/auth';
import { ToastMessage } from 'primereact/toast';
import { getBrowserFingerprint } from '@/utils/fingerprint';
import { errorMessage } from '@/vars/errorMessages';
import { useRouter } from 'next/navigation';
import { MD5 } from 'crypto-js'

const LoginForm = ( { loginUser } : { loginUser: (login: string, password: string, fingerprint: string) => Promise<ServerResponse<AuthServerResponse>> } ) => {
  const router = useRouter();

  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  // const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  const validate = () => {
    const errToastArr:ToastMessage[] = [];

    if (login.length < 3) errToastArr.push({severity:'warn', summary:'Login is empty'});
    if (password.length < 3) errToastArr.push({severity:'warn', summary:'Password is empty'});
    
    if (errToastArr.length > 0) {
      toastRef.current?.show(errToastArr);
      return false;
    }

    return true;
  }

  const authUser = async () => { 
    if (!validate()) return false;
    setDisabled(true);

    const loginResult = await loginUser(login, MD5(password).toString(), getBrowserFingerprint());

    if (loginResult.status == 'error') {
      toastRef.current?.show({severity:'error', summary: 'Auth error', detail: errorMessage[loginResult.message || ''] || loginResult.message  })
    }
    
    setDisabled(false);

    if (loginResult.status == 'ok') {
      router.push('/manage')
    }
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    authUser();
  };

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <Card className="w-full surface-card py-5 px-5">
          <div className="w-full surface-card" style={{ borderRadius: '53px' }}>
            <div className="text-center mb-5">
              <div className="text-900 text-3xl font-medium mb-3">Welcome!</div>
              <span className="text-600 font-medium">Enter your credentials</span>
            </div>

            <form onSubmit={handleSubmit}>
              <div>
                <label htmlFor="login" className="block text-900 text-xl font-medium mb-2">
                  Login
                </label>
                <InputText
                  id="login"
                  type="text"
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  placeholder="Login"
                  className="w-full mb-5"
                  style={{ padding: '1rem' }}
                />

                <label htmlFor="password" className="block text-900 font-medium text-xl mb-2">
                  Password
                </label>
                <Password
                  inputId="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  // toggleMask
                  feedback={false}
                  className="w-full mb-5"
                  inputClassName="w-full p-3"
                />

                {/* <div className="flex align-items-center justify-content-between mb-5 gap-5"> */}
                  {/* <div className="flex align-items-center">
                    <Checkbox
                      inputId="rememberme"
                      checked={checked}
                      onChange={(e) => setChecked(e.checked ?? false)}
                      className="mr-2"
                    />
                    <label htmlFor="rememberme">Запомнить меня</label>
                  </div> */}
                  {/* <a className="font-medium no-underline ml-2 text-right cursor-pointer" style={{ color: 'var(--primary-color)' }}>
                    Забыли пароль?
                  </a> */}
                {/* </div> */}
                <Button
                  type="submit"
                  label="Login"
                  className="w-full p-3 text-xl"
                  disabled={disabled}
                />
              </div>
            </form>
          </div>
        </Card>
      </div>
    </div>
  );
};


export default LoginForm;